export default "__VITE_ASSET__BGS3GQAU__"